import Cookies from 'js-cookie'

// 从 Cookie 中获取到 Token
export function getCookies(key) {
  return Cookies.get(key)
}

// 在 Cookie 中储存 token
export function setCookies(key, data) {
  return Cookies.set(key, data)
}

// 从 Cookie 中移除 token
export function removeCookies(key) {
  return Cookies.remove(key)
}